import { c as classNames } from '../../shared/bind-d9144132.js';
import { getTestId } from '../../utils/testId.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "navigation": "web_ui__Navigation__navigation",
  "content": "web_ui__Navigation__content",
  "left": "web_ui__Navigation__left",
  "right": "web_ui__Navigation__right",
  "body": "web_ui__Navigation__body",
  "primary": "web_ui__Navigation__primary",
  "amplified": "web_ui__Navigation__amplified",
  "muted": "web_ui__Navigation__muted",
  "success": "web_ui__Navigation__success",
  "warning": "web_ui__Navigation__warning",
  "expose": "web_ui__Navigation__expose",
  "transparent": "web_ui__Navigation__transparent"
};

var cssClasses = classNames.bind(styles);
var Navigation = function Navigation(_ref) {
  var left = _ref.left,
    right = _ref.right,
    body = _ref.body,
    children = _ref.children,
    theme = _ref.theme,
    testId = _ref.testId;
  var navigationClass = cssClasses('navigation', theme);
  return /*#__PURE__*/jsx("div", {
    className: navigationClass,
    "data-testid": testId,
    children: /*#__PURE__*/jsxs("div", {
      className: styles.content,
      children: [/*#__PURE__*/jsx("div", {
        className: styles.left,
        "data-testid": getTestId(testId, 'left'),
        children: left
      }), /*#__PURE__*/jsx("div", {
        className: styles.body,
        "data-testid": getTestId(testId, 'body'),
        children: body || children
      }), /*#__PURE__*/jsx("div", {
        className: styles.right,
        "data-testid": getTestId(testId, 'right'),
        children: right
      })]
    })
  });
};

export { Navigation as default };
//# sourceMappingURL=Navigation.js.map
